
export const formProps = [
  {
    label: "Prénom et Nom",
    type: "text",
    placeholder: "Votre nom complet",
    id: "name",
    paddingB:
      "!h-[2.4rem] !w-[60%] !rounded-r-lg !bg-transparent border-grayborder/60 !shadow-none !text-sm ps-4",
    labelStyle:
      "text-xs font-inter px-2 !w-[40%] bg-blc !h-[2.4rem] flex items-center border !border-grayborder/90 rounded-l-lg",
    errorStyle: "text-red text-sm italic",
    errorMessage: "Le prénom et nom est requis",
  },
  {
    label: "Email",
    type: "text",
    placeholder: "Votre adresse email",
    id: "email",
    paddingB:
      "!h-[2.4rem] !rounded-r-lg !w-[60%] !bg-transparent border-grayborder/70 !shadow-none !text-xs ps-4",
    labelStyle:
      "text-xs font-inter px-2 gap-1 !w-[40%] bg-blc !h-[2.4rem] flex items-center border !border-grayborder rounded-l-lg",
    errorStyle: "text-red text-sm italic",
    errorMessage: "L'email est requis",
  },
  {
    label: "Téléphone",
    type: "number",
    id: "number",
    placeholder: "Votre numéro de téléphone ",
    paddingB:
      "!h-[2.4rem] !rounded-r-lg !w-[60%] !bg-transparent border-grayborder/70 !shadow-none !text-xs ps-4",
    labelStyle:
      "text-xs font-inter px-2 gap-1 !w-[40%] bg-blc !h-[2.4rem] flex items-center border !border-grayborder rounded-l-lg",
    errorStyle: "text-red text-sm italic",
    errorMessage:
      "Le numéro de téléphone doit comporter entre 9 et 15 chiffres.",
  },

  {
    label: "Le nom de votre projet",
    type: "text",
    id: "titre",
    placeholder: "Le nom de votre projet",
    paddingB:
      "!h-[2.4rem] !rounded-r-lg !w-[60%] !bg-transparent border-grayborder/70 !shadow-none !text-xs ps-4",
    labelStyle:
      "text-xs font-inter px-2 gap-1 !w-[40%] bg-blc !h-[2.4rem] flex items-center border !border-grayborder rounded-l-lg",
    errorStyle: "text-red text-sm italic",
    errorMessage: "Le nom de votre projet est requis",
  },
  {
    label: "Votre budget en FCFA(XOF)",
    type: "number",
    id: "budget",
    placeholder: "Votre budget en FCFA(XOF)",
    paddingB:
      "!h-[2.4rem] !rounded-r-lg !w-[60%] !bg-transparent border-grayborder/70 !shadow-none !text-xs ps-4",
    labelStyle:
      "text-xs font-inter px-2 gap-1 !w-[40%] bg-blc !h-[2.4rem] flex items-center border !border-grayborder rounded-l-lg",
    // suffix: (
    //   <div className="rounded-r-lg text-center items-center flex text-xs px-5 text-blc bg-vr -ms-[70px] ">
    //     FCFA
    //   </div>
    // ),
    errorStyle: "text-red text-sm italic ",
    errorMessage: "Votre budget en FCFA(XOF) est requis",
  },
];

export const formLabelImage = (preview) => {
  return (<div className="flex flex-col gap-1 w-full">
    <div className="h-72 flex justify-center items-center w-full rounded-md text-xs bg-transparent border border-grayborder">{preview}</div>
  </div>)
}

export const formPropsLinkAndObj = [
  // {
  //   label: "Objectif du projet",
  //   type: "text",
  //   id: "objectif",
  //   paddingB:
  //     "!h-[2.4rem] !rounded-r-lg !w-[60%] !bg-transparent border-grayborder/70 !shadow-none !text-xs ps-4",
  //   labelStyle:
  //     "text-xs font-inter px-2 gap-1 !w-[40%] bg-blc !h-[2.4rem] flex items-center border !border-grayborder rounded-l-lg",
  //   errorStyle: "text-red text-sm italic ",
  //   errorMessage: "L'objectif du projet est requis",
  // },
  // {
  //   label: "Fichier de moins de 5 Mo (lien)",
  //   type: "url",
  //   id: "document",
  //   paddingB:
  //     "!h-[2.4rem] !rounded-r-lg !w-[60%] !bg-transparent border-grayborder/70 !shadow-none !text-xs ps-4",
  //   labelStyle:
  //     "text-xs font-inter px-2 gap-1 !w-[40%] bg-blc !h-[2.4rem] flex items-center border !border-grayborder rounded-l-lg",
  //   errorStyle: "text-red text-sm italic ",
  //   errorMessage: "Le document associé au projet est requis",
  // },
];



//======================== client ========================//



export const formClientSideProps = [
  {
    label: "Le nom de votre projet",
    type: "text",
    id: "titre",
    placeholder: "Le nom de votre projet",
    paddingB:
      "!h-[2.4rem] !rounded-r-lg !w-[60%] !bg-transparent border-grayborder/70 !shadow-none !text-xs ps-4",
    labelStyle:
      "text-xs font-inter px-2 gap-1 !w-[40%] bg-blc !h-[2.4rem] flex items-center border !border-grayborder rounded-l-lg",
    errorStyle: "text-red text-sm italic",
    errorMessage: "Le prénom et nom est requis",
  },
  {
    label: "Votre budget en FCFA(XOF)",
    type: "number",
    id: "budget",
    placeholder: "Votre budget",
    paddingB:
      "!h-[2.4rem] !rounded-r-lg !w-[60%] !bg-transparent border-grayborder/70 !shadow-none !text-xs ps-4",
    labelStyle:
      "text-xs font-inter px-2 gap-1 !w-[40%] bg-blc !h-[2.4rem] flex items-center border !border-grayborder rounded-l-lg",
    suffix: (
      <div className="rounded-r-lg text-center items-center flex text-xs px-5 text-blc bg-vr -ms-[70px] ">
        FCFA
      </div>
    ),
    errorStyle: "text-red text-sm italic ",
    errorMessage: "Votre budget en FCFA(XOF) est requis",
  },
];